<template>
    <div class="consultation-multi">
        <bread-crumb :bread-list="breadList" />

        <div class="consultation-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">多学科会诊</span>
            </div>
            <div class="add-wrap">
                <el-button @click="handleAddNew">新增多学科会诊</el-button>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="会诊名称"
                                     prop="name">
                    </el-table-column>

                    <el-table-column label="状态">
                        <template slot-scope="{row}">
                            <div v-if="row.state === 'ONLINE'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-if="row.state === 'OFFLINE'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已下线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序">
                        <template slot-scope="{row}">
                            <div class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveIndex(row.mdtId, 'UP')"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveIndex(row.mdtId, 'DOWN')"></i>

                                <i class="iconfont icon-zhiding icon-off"
                                   v-if="row.noMoveUp"></i>
                                <i class="iconfont icon-zhiding icon-on"
                                   @click="handleMoveTop(row.mdtId)"
                                   v-else></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"
                                     width="180px">
                        <template slot-scope="{row}">
                            <div v-if="row.state === 'ONLINE'">
                                <span class="link-btn"
                                      @click="handlePutState(row)">下线</span>
                                <span class="link-btn"
                                      @click="handleEditClick(row)">编辑</span>
                                <span class="link-btn"
                                      @click="hanldeDeleMessage(row)">删除</span>
                            </div>
                            <div v-if="row.state === 'OFFLINE'">
                                <span class="link-btn"
                                      @click="handlePutState(row)">上线</span>
                                <span class="link-btn"
                                      @click="handleEditClick(row)">编辑</span>
                                <span class="link-btn"
                                      @click="hanldeDeleMessage(row)">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>

        <el-drawer title="标题"
                   :visible.sync="drawer"
                   :wrapper-closable="false"
                   size="500px"
                   custom-class="multi-drawer">
            <div class="drawer-wraper">
                <div class="title-icon">
                    <i class="iconfont icon-tongyongbiaotiicon"></i>
                    <span class="title-text">{{ drawerName }}</span>
                </div>
                <div>
                    <i class="el-icon-close"
                       @click="drawer = false"></i>
                </div>
            </div>

            <el-form :model="drawerForm"
                     ref="drawerForm"
                     v-loading="drawerFormLoading"
                     label-width="160px"
                     class="drawer-form">
                <el-form-item label="多学科会诊名称"
                              prop="name"
                              :rules="[{ required: true, message: '请输入多学科会诊名称', trigger: 'change' }]">
                    <el-input v-model="drawerForm.name"
                              class="form-input"
                              placeholder="请输入多学科会诊名称"></el-input>
                </el-form-item>

                <el-form-item label="疾病名称"
                              prop="disase"
                              :rules="[{ required: true, message: '请选择疾病名称', trigger: 'change' }]">
                    <el-select filterable
                               class="form-select"
                               clearable
                               remote
                               popper-class="multi-popper"
                               :remote-method="getDisaseList"
                               :loading="disaseLoading"
                               loading-text="正在搜索疾病名称，请稍后..."
                               v-model="drawerForm.disase"
                               placeholder="请输入内容查询疾病名称"
                               @change="currentSelect($event)"
                               @clear="currentSelect">
                        <el-option v-for="item in diseaseOptions"
                                   :key="item.diseaseId"
                                   :label="item.diseaseName"
                                   :value="item.diseaseId">
                        </el-option>
                        <div slot="empty"
                             class="multi-select-empty">
                            <i class="el-icon-info"></i>
                            <span class="info-text">无数据</span>
                        </div>
                    </el-select>
                </el-form-item>
                <!-- 会诊科室 因后台原因 暂不上线 -->
                <el-form-item label="会诊科室"
                              prop="departListShow"
                              :rules="[{ required: true, message: '请选择会诊科室', trigger: 'change' }]">
                    <div class="label-team-content-wrap">
                        <div class="label-team-select" @click="showDepartList">
                            <i class="el-icon-circle-plus-outline"></i>
                            <span>选择科室</span>
                        </div>
                        <div class="label-team-content" v-if="drawerForm.departListShow.length>0">
                            <div class="team-content-item" v-for="(item, index) in drawerForm.departListShow" :key="index">
                                <span class="wow-folder"></span>
                                <span>{{item.name}}</span>
                                <i class="el-icon-close wow-close"
                                    @click="hanldeDeleShow(item.groupId,index)"></i>
                            </div>
                        </div>
                    </div>
                </el-form-item>

            </el-form>

            <div class="drawer-bottom">
                <el-button class="confirm-btn"
                           @click="handleConfirm">确 定</el-button>
                <el-button class="cancle-btn"
                           @click="drawer = false">取 消</el-button>
            </div>
        </el-drawer>

        <message-box :dialog-visible="messageVisible"
                     :id="mdtId"
                     warning-text="您确定要删除该会诊吗？"
                     @handleConfirm="handleMessageConfirm"
                     @handleClose="handleMessageClose" />
        <!-- 选择科室 -->
        <el-dialog title="选择科室"
                   :visible.sync="dialogDepart"
                   custom-class="member-wow-wel-dialog"
                   :before-close="clearReturnTwo"
                   width="560px">
            <div class="member-content">
                <div class="left-wraper">
                    <div class="search-content">
                        <el-input class="search-tema"
                                  placeholder="输入科室名称查询"
                                  v-model.trim="memberForm.departName"
                                  @keyup.enter.native="getDepartList">
                            <i slot="suffix"
                               class="iconfont icon-search"
                               @click="getDepartList"></i>
                        </el-input>
                    </div>

                    <div class="dialog-tema-content">
                        <el-checkbox-group v-model="checkedDeparts" v-if="dialogDepartList.length>0">
                            <el-checkbox v-for="item in dialogDepartList"
                                         :key="item.groupId"
                                         :label="item.groupId"
                                         @change="changeRightNow(item)"><img class="depart-icon" src="../../../assets/imgs/folder.png" alt="">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                        <div class="dialog-none-data" v-else>
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </div>

                </div>
                <div class="right-wraper">
                    <div class="content_text">
                        <div class="choose_text">已选择（{{ chooseDataTwo.length }}）</div>
                        <div class="empty_text"
                             @click="handleClear">清空</div>
                    </div>
                    <div class="choose-member">
                        <div v-for="(item, index) in chooseDataTwo"
                             :key="index"
                             class="item-member">
                            <div>
                                <img class="depart-icon" src="../../../assets/imgs/folder.png" alt="">
                                <label class="member-text">{{item.name}}</label>
                            </div>
                            <div>
                                <i class="el-icon-close"
                                   @click="hanldeDeleMemberTwo(item.groupId,index)"></i>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button type="primary"
                           @click="chooseMember"
                           class="dialog-confirm-btn">确 定</el-button>
                <el-button @click="clearReturnTwo"
                           class="dialog-cancle">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import MessageBox from '@/components/MessageBox'
import { postMdtClinicList, putMdtClinicState, getSearchDisease, deleteMdtClinic, postAddMdtClinic, getMdtClinicDetail, putEditMdtClinic, putMdtChangeIndex, putMdtChangeIndexTop, postClinicGroupList } from '@/api/consultation'
export default {
    name: 'consultationMultidisciplinary',
    data () {
        return {
            loading: false,
            drawer: false,
            messageVisible: false,
            drawerFormLoading: false,
            disaseLoading: false,
            breadList: [{ label: '运营管理' }, { label: '会诊管理', path: '/operation/consultation' }, { label: '多学科会诊编辑' }],
            dataList: [{}],
            drawerForm: {
                name: '',
                disase: '',
                departListShow: []
            },
            drawerName: '',
            drawerType: '',
            mdtId: '',
            diseaseOptions: [],
            clinicId: this.$route.query.clinicId,
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            details: {},
            disease: {},
            // 会诊科室
            dialogDepart: false,
            dialogDepartList: [],
            chooseDataTwo: [],
            checkedDeparts: [],
            departListShow: [],
            memberForm: {
                temaName: '',
                departName: ''
            }
        }
    },
    components: { MessageBox },
    methods: {
        async getDisaseList (value) {
            if (value) {
                this.disaseLoading = true
                const { results } = await getSearchDisease(value)
                this.diseaseOptions = results.result
                this.disaseLoading = false
            } else {
                this.disease = {}
                this.diseaseOptions = []
            }
        },
        currentSelect (diseaseId) {
            if (diseaseId) {
                let obj = {}
                obj = this.diseaseOptions.find(item => {
                    return item.diseaseId === diseaseId
                })
                this.disease = obj
            } else {
                this.disease = {}
                this.diseaseOptions = []
            }
        },
        // 点击新增多学科会诊
        handleAddNew () {
            this.drawer = true
            this.drawerForm.name = ''
            this.drawerForm.disase = ''
            this.drawerName = '新增多学科会诊'
            this.drawerType = 'add'
            this.disease = {}
            this.diseaseOptions = []
            if (this.$refs['drawerForm']) {
                this.$refs['drawerForm'].resetFields()
            }
            // 清除会诊科室
            this.drawerForm.departListShow = []
            this.chooseDataTwo = []
            this.checkedDeparts = []
            // this.queryDisease()
        },
        // 查询会诊疾病
        // async queryDisease () {
        //     const { results } = await getSearchDisease()
        //     this.diseaseOptions = results.result
        // },
        //  上下线
        async handlePutState (row) {
            let state = ''
            let message = ''
            if (row.state === 'ONLINE') {
                state = 'OFFLINE'
                message = '下线成功'
            } else if (row.state === 'OFFLINE') {
                state = 'ONLINE'
                message = '上线成功'
            }
            const { results } = await putMdtClinicState(row.mdtId, state)
            if (results === 'success') {
                this.$message({
                    message: message,
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.queryList(this.page.current)
            }
        },
        // 上移   下移
        async handleMoveIndex (mdtId, type) {
            const { results } = await putMdtChangeIndex(mdtId, type)
            if (results === 'success') {
                this.queryList(this.page.current)
            }
        },
        // 置顶
        async handleMoveTop (mdtId) {
            const { results } = await putMdtChangeIndexTop(mdtId)
            if (results === 'success') {
                this.queryList(this.page.current)
            }
        },
        hanldeDeleMessage (row) {
            this.messageVisible = true
            this.mdtId = row.mdtId
        },
        handleMessageClose () {
            this.messageVisible = false
        },
        async handleMessageConfirm (mdtId) {
            const { state } = await deleteMdtClinic(mdtId)
            if (state === 200) {
                this.$message({
                    message: '成功删除该团队',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.messageVisible = false
                this.queryList(this.page.current)
            }
        },
        // 点击编辑多学科会诊
        async handleEditClick (row) {
            if (this.$refs['drawerForm']) {
                this.$refs['drawerForm'].clearValidate()
            }
            this.drawerFormLoading = true
            this.drawerType = 'edit'
            this.drawerName = '编辑多学科会诊'
            this.drawer = true
            // this.queryDisease()
            const { results } = await getMdtClinicDetail(row.mdtId)
            this.details = results
            this.drawerForm.name = results.name
            this.drawerForm.disase = results.disase
            this.drawerForm.departListShow = results.dept || []
            this.chooseDataTwo = JSON.parse(JSON.stringify(results.dept)) || []
            this.checkedDeparts = []
            results.dept.forEach((item, index) => {
                this.checkedDeparts.push(item.groupId)
            })
            this.drawerFormLoading = false
        },
        handleCurrentChange (val) {
            this.page.current = val
            this.queryList()
        },
        handleConfirm () {
            this.$refs['drawerForm'].validate((valid) => {
                if (valid) {
                    this.saveMdtClinic()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async saveMdtClinic () {
            this.drawerFormLoading = true
            if (this.drawerType === 'add') {
                let params = {
                    clinicId: this.clinicId,
                    name: this.drawerForm.name,
                    disase: this.disease.diseaseName,
                    code: this.disease.icd10,
                    // 会诊科室 因后台原因 暂不上线
                    deptId: this.checkedDeparts
                }

                const { results } = await postAddMdtClinic(params)
                if (results) {
                    this.$message({
                        message: '成功新增会诊',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                    this.drawer = false
                    this.queryList()
                }
            }

            if (this.drawerType === 'edit') {
                let params = {
                    clinicId: this.clinicId,
                    name: this.drawerForm.name,
                    disase: this.disease.diseaseName,
                    code: this.disease.icd10,
                    state: this.details.state,
                    deptId: this.checkedDeparts
                }

                const { results } = await putEditMdtClinic(this.details.mdtId, params)
                if (results) {
                    this.$message({
                        message: '成功修改会诊',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                    this.drawer = false
                    this.queryList()
                }
            }

            this.drawerFormLoading = false
        },
        async queryList () {
            let params = {
                clinicId: this.clinicId,
                page: this.page.current,
                size: this.page.pageSize
            }
            this.dataList = []
            this.loading = true
            const { results, total } = await postMdtClinicList(params)
            if (results && results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    let data = results[i]
                    if (data.orderIndexFlag === 'first') {
                        this.$set(data, 'noMoveUp', true)
                    }
                    if (data.orderIndexFlag === 'last') {
                        this.$set(data, 'noMoveDown', true)
                    }
                }
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryList()
                }
            }
            this.loading = false
        },
        // 会诊科室------
        showDepartList () {
            this.dialogDepart = true
            this.getDepartList()
        },
        // 获取科室列表
        async getDepartList () {
            this.departLoading = true
            let params = {
                state: 'ONLINE',
                type: 'DEPT',
                page: 1,
                size: 1000
            }
            if (this.memberForm.departName) {
                params.name = this.memberForm.departName
            }
            const { results, state } = await postClinicGroupList(params)
            if (results && state === 200) {
                this.dialogDepartList = results
            }
            this.departLoading = false
        },
        // 清除信息科室
        clearReturnTwo () {
            this.memberForm.departName = ''
            this.chooseDataTwo = JSON.parse(JSON.stringify(this.drawerForm.departListShow))
            this.checkedDeparts = []
            this.dialogDepart = false
            this.drawerForm.departListShow.forEach((item, index) => {
                this.checkedDeparts.push(item.groupId)
            })
        },
        // 科室修改右侧
        changeRightNow (val) {
            let chooseId = this.checkedDeparts
            if (chooseId.indexOf(val.groupId) !== -1) {
                chooseId.forEach((choose, index) => {
                    if (val.groupId === choose) {
                        this.chooseDataTwo.push(val)
                    }
                })
            } else {
                this.chooseDataTwo.forEach((item, index) => {
                    if (val.groupId === item.groupId) {
                        this.chooseDataTwo.splice(index, 1)
                    }
                })
            }
        },
        handleClear () {
            this.chooseDataTwo = []
            this.checkedDeparts = []
        },
        // 科室确定
        hanldeDeleMemberTwo (groupId, index) {
            let chooseId = this.checkedDeparts
            chooseId.forEach((item, key) => {
                if (item === groupId) {
                    this.checkedDeparts.splice(key, 1)
                }
            })
            this.chooseDataTwo.splice(index, 1)
        },
        chooseMember () {
            this.memberForm.departName = ''
            this.drawerForm.departListShow = JSON.parse(JSON.stringify(this.chooseDataTwo))
            this.dialogDepart = false
            this.$refs['drawerForm'].validateField('departListShow')
        },
        // 列表删除
        hanldeDeleShow (groupId, index) {
            this.drawerForm.departListShow.splice(index, 1)
            this.hanldeDeleMemberTwo(groupId, index)
            this.$refs['drawerForm'].validateField('departListShow')
        }
        // 会诊科室结束------

    },
    mounted () {
        this.queryList()
    }
}
</script>

<style lang="scss" scoped>
.label-team-content-wrap {
    .label-team-select {
        // margin-bottom: 10px;
        color: $color-primary;
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
            font-size: 18px;
            margin-right: 8px;
        }
    }
    .label-team-content {
        margin-bottom: 60px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        .team-content-item {
            margin-top: 10px;
            margin-right: 10px;
            display: flex;
            align-items: center;
            height: 24px;
            padding: 0 10px;
            border: 1px solid #F2F2F2;
            border-radius: 3px;
            color: #333333;
            .wow-user {
                margin-right: 10px;
                font-size: 10px;
                color: $color-primary;
            }
            .wow-close {
                margin-left: 10px;
                font-size: 6px;
                color: #999999;
                cursor: pointer;
            }
            .wow-folder {
                margin-right: 10px;
                width: 11px;
                height: 11px;
                display: inline-block;
                background: url("../../../assets/imgs/folder.png") no-repeat;
                background-size: cover;
            }
        }
    }
}
// 科室
    .dialog-tema-content {
        padding-right: 10px;
        height: 400px;
        overflow: auto;
        .dialog-tema-item {
            margin-bottom: 14px;
            display: flex;
            justify-content: space-between;
            .dialog-tema-item-left {
                span {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 12px;
                }
            }
            .wow-user {
                margin-right: 10px;
                font-size: 10px;
                color: $color-primary;
            }
        }
    }
    // 无数据
    .dialog-none-data {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon {
            font-size: 80px;
        }
        span {
            line-height: 14px;
            font-size: 12px;
        }
    }
</style>

<style lang="scss">
.dialog-tema-content {
    // checkbox
    .el-checkbox-group {
        .el-checkbox {
            display: flex;
            justify-content: space-between;
            flex-flow: row-reverse;
            margin-bottom: 14px;
            margin-right:0px;
            .el-checkbox__label {
                padding-left: 0px;
                font-size: 12px;
                float: left;
                color: #333333;
                i {
                    margin-right: 10px;
                    font-size: 12px;
                    color: $color-primary;
                }
                .depart-icon {
                    margin-right: 10px;
                }
            }
        }
    }
}
.depart-icon {
    display: inline-block;
    width: 14px;
    height: 12px;
}
// 标签弹窗布局
.el-dialog__wrapper {
    .member-wow-wel-dialog {
        .el-dialog__body {
            padding: 0;
            .member-content {
                height: 453px;
                display: flex;
                .left-wraper {
                    padding-left: 10px;
                    width: 340px;
                    border-right: 1px solid #dcdcdc;
                    .search-content {
                        margin: 10px 0;
                        width: 319px;
                        padding-right: 10px;
                        .search-tema {
                            width: 319px;
                            vertical-align: middle;
                            .el-input__inner {
                                border-radius: 3px;
                                border-color: #dcdcdc;
                                padding: 8px 32px 8px 10px;
                                height: 32px;
                                font-size: 12px;
                            }
                            .el-input__inner::-webkit-input-placeholder {
                                font-size: 12px;
                            }

                            .el-input__suffix {
                                background: $color-primary;
                                color: #fff;
                                right: 0;
                                cursor: pointer;
                                border-radius: 0 3px 3px 0;

                                i {
                                    display: inline-block;
                                    width: 36px;
                                    font-size: 14px;
                                    line-height: 32px;
                                    border-radius: 3px;
                                }
                            }
                        }
                    }
                    .table-content {
                        margin-top: 10px;
                    }
                }
                .right-wraper {
                    width: 220px;
                    padding: 20px;
                    padding-right: 0px;
                    overflow: hidden;
                    .content_text {
                        padding-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .choose_text {
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                        }
                        .empty_text {
                            cursor: pointer;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #198eeb;
                            letter-spacing: 0;
                        }
                    }
                    .choose-member {
                        height: 396px;
                        padding-right: 20px;
                        overflow: auto;
                        margin-top: 10px;
                        padding-top: 10px;
                        .item-member {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            .icon-user1 {
                                font-size: 14px;
                                color: #06aea6;
                            }
                            .el-icon-close {
                                color: #999;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .member-text {
                                margin-left: 10px;
                                font-family: PingFangSC-Regular;
                                font-size: 12px;
                                color: #333333;
                                letter-spacing: 0;
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            background: #f9f9f9;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .dialog-footer {
                .dialog-confirm-btn {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                }
                .dialog-cancle {
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    border-radius: 3px;
                    padding: 0;
                    width: 100px;
                    height: 32px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    margin-left: 16px;
                }
            }
        }
    }
}
.consultation-multi {
    .consultation-content {
        min-height: 600px;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        background: #fff;
        overflow: auto;
        padding: 20px 20px 0 20px;
        .title-wrap {
            padding-bottom: 20px;
            display: flex;
            align-items: center;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
        .add-wrap {
            margin-bottom: 20px;
            .el-button {
                height: 32px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                border-radius: 3px;
                padding: 0 14px;
            }
        }
        .table-wrap {
            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                display: flex;
                align-items: center;
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                    margin-right: 10px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 10px;
                }
                .icon-zhiding {
                    font-size: 20px;
                }
            }

            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
    }
}
.el-dialog__wrapper, .el-drawer__wrapper {
    .multi-drawer {
        .el-drawer__header {
            display: none;
        }
        .el-drawer__body {
            position: relative;
            overflow: auto;
            .drawer-wraper {
                margin: 20px;
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #ccc;
                padding-bottom: 10px;
                .title-icon {
                    display: flex;
                    align-items: center;
                    .icon-tongyongbiaotiicon {
                        color: $color-primary;
                        font-size: 16px;
                        vertical-align: middle;
                    }
                    .title-text {
                        font-size: 14px;
                        color: #4a4a4a;
                        margin-left: 10px;
                        display: inline-block;
                        height: 16px;
                        line-height: 16px;
                        vertical-align: middle;
                    }
                }
                .el-icon-close {
                    cursor: pointer;
                    color: #999;
                    font-size: 20px;
                }
            }
            .drawer-form {
                margin-top: 20px;
                .form-input {
                    width: 250px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                        height: 32px;
                        border-radius: 3px;
                    }
                }
                .form-select {
                    .el-input {
                        width: 250px;
                        .el-input__inner {
                            border-radius: 3px;
                            border: 1px solid #dcdcdc;
                            height: 32px;
                            padding: 0 10px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }
            }
            .drawer-bottom {
                position: fixed;
                bottom: 0;
                right: 0;
                background: #f7f7f7;
                width: 500px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                .confirm-btn {
                    background: #ff7631;
                    border-radius: 3px;
                    width: 120px;
                    height: 34px;
                    padding: 0;
                    border: none;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #ffffff;
                }
                .cancle-btn {
                    width: 120px;
                    height: 34px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #d6d6d6;
                    border-radius: 3px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    margin-left: 16px;
                }
            }
        }
    }
}
.multi-popper {
    .el-scrollbar {
        height: 240px;
        width: 250px;
        .el-select-dropdown__item {
            padding: 0 10px;
        }
    }
    .multi-select-empty {
        position: absolute;
        top: 116px;
        left: 87px;
        .el-icon-info {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.3);
        }
        .info-text {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            margin-left: 8px;
        }
    }
}
</style>
